/**
 * Get config from props and fallback to defaultConfig if not exist
 *
 * @param {object} localConfig local config from site app
 * @param {object} ruleName Rule name key in localConfig
 * @param {Array} defaultConfig Default config to fallback to
 * @param {object} props to supplied to localConfig if exist
 * @returns {Array}
 */
const getConfig = ({
  localConfig, ruleName, defaultConfig, props,
}) => {
  if (localConfig[ruleName] && typeof localConfig[ruleName] === 'function') {
    return localConfig[ruleName](props);
  }

  return defaultConfig;
};

export default getConfig;
